import { RouteConfig } from "vue-router";

const legales: RouteConfig = {
  path: "/legales",
  name: "legales",
  component: () => import(/* webpackChunkName: "legales" */ "@/views/Legales.vue"),
};

export default legales;
